import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import { printTableWithHeader } from "../../../utils/printUtils";
import "./ViewTalentPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;

export default function ViewTalentPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [talent, setTalent] = useState(null);
  const [loading, setLoading] = useState(true);

  // FETCH TALENT
  useEffect(() => {
    const fetchTalent = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/talent/${id}`);
        setTalent(res.data); // ✅ Use res.data directly
      } catch (err) {
        console.error("Failed to fetch talent:", err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchTalent();
  }, [id]);

  // PRINT PROFILE
  const handlePrint = () => {
    if (!talent) return;

    printTableWithHeader({
      title: "Talent Profile",
      summary: `${talent.name} - ${talent.field}`,
      columns: [
        { key: "label", label: "Field" },
        { key: "value", label: "Details" },
      ],
      rows: [
        { label: "Name", value: talent.name },
        { label: "Field", value: talent.field },
        { label: "Qualification", value: talent.qualification },
        { label: "Status", value: talent.status },
        { label: "Approved By", value: talent.approvedBy || "N/A" },
        { label: "CV Link", value: talent.cvLink },
      ],
    });
  };

  if (loading) return <div className="view-talent-loading">Loading talent...</div>;
  if (!talent) return <div className="view-talent-loading">Talent not found</div>;

  return (
    <div className="view-talent-page">
      {/* ACTIONS */}
      <div className="view-talent-actions">
        <button onClick={() => navigate(-1)} className="btn-back">
          <ArrowLeft size={16} /> Go Back
        </button>
        <button onClick={handlePrint} className="btn-print">
          <Printer size={16} /> Print
        </button>
      </div>

      {/* PHOTO */}
      <div className="view-talent-photo-wrapper">
        <img src={talent.photo} alt={talent.name} className="view-talent-photo" />
        <h1 className="talent-name">{talent.name}</h1>
        <p className="talent-field">{talent.field}</p>
      </div>

      {/* CARD */}
      <div className="view-talent-card">
        <div className={`status-badge status-${talent.status}`}>
          {talent.status.toUpperCase()}
        </div>

        <div className="talent-details">
          <div className="detail-item">
            <span>Qualification</span>
            <p>{talent.qualification}</p>
          </div>
          <div className="detail-item">
            <span>Approved By</span>
            <p>{talent.approvedBy || "Not yet approved"}</p>
          </div>
          <div className="detail-item">
            <span>CV</span>
            <a href={talent.cvLink} target="_blank" rel="noreferrer">
              View CV
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}